import Component from 'inferno-component';
import ProjectInfo from '../ProjectInfo/ProjectInfo';
import RadialChart from '../RadialChart/RadialChart';
import BarChart from '../BarChart/BarChart';
import Search from '../Search/Search';
import Data from '../Data';
import Gallery from '../Gallery/Gallery';
import ResumeView from '../ResumeView/ResumeView';
import './App.css';
import './AppMainMenu.css';
import './AppMobile.css';
import './Welcome.css';
import './WelcomeMobile.css';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isResumeViewVisible: true,
      searchString: '',
      relatedSkillsVsExperience: [],
      projectSkillsVsExperience: [],
      projectSkillsVsProjectCount: [],
      indexData: [],
      mainMenuClass: 'main-menu'
    };
  }

  componentDidMount() {
    this.init();
  }

  init() {
    let welcomePreviouslyViewed = window.localStorage.getItem('welcomePreviouslyViewed');
    this.setState({
      indexData: Data.indexData,
      selectedSkill: Data.indexData[0],
      welcomePreviouslyViewed: welcomePreviouslyViewed
    });

    this.setAllPhotos();
    // setTimeout(()=> {
    //   this.initSelectedProject();
    // }, 100);
  }

  setAllPhotos() {
    let projectScreenshots = [];
    Data.indexData.forEach(function(skill) {
      if (skill.projects) {
        skill.projects.forEach(function(project) {
          if (project.images) {
            project.images.forEach(function(image) {
              projectScreenshots.push({ file: image.file, caption: image.caption, project: project.name, url: project.url });
            });
          }
        });
      }
    });
    this.setState({ projectScreenshots: projectScreenshots });
  }

  initSelectedProject() {
    let projectElements = document.getElementsByClassName('project');
    let event = document.createEvent('Event');
    event.initEvent('click', true, true);
    projectElements[0].dispatchEvent(event);
  }

  selectedRandomProject = ()=> {
    let projectElements = document.getElementsByClassName('project');
    let randomProjectIndex = Math.floor(Math.random() * projectElements.length);
    let svgEvent = document.createEvent('Event');
    svgEvent.initEvent('click', true, true);
    projectElements[randomProjectIndex].dispatchEvent(svgEvent);
    this.closeMainMenu();
  }

  handleSelectedRandomProject = (event)=> {
    event.stopPropagation();
    this.selectedRandomProject();
  }

  filterIndexData(searchString) {
    let selectedSkill = this.state.indexData[0];
    searchString = searchString.replace(/[^\w-_ ]/g, '');

    if (searchString !== '') {
      let searchRx = new RegExp('^' + searchString, 'i');

      this.state.indexData.forEach(function(datum) {
        if (datum.name.match(searchRx)) {
          datum.isSelected = true;
          selectedSkill = datum;
        } else {
          datum.isSelected = false;
        }
      });
    } else {
      // Select all skills when the search string is empty
      this.state.indexData.forEach(function(datum) {
        datum.isSelected = true;
      });
    }

    this.setState({ selectedSkill: selectedSkill });
  }

  handleSearchStringChange = (searchString)=> {
    this.setState({ searchString: searchString });
    this.filterIndexData(searchString);
  }

  uuid() {
    return ('' + Math.random()).slice(2);
  }

  onSelectProject = (project)=> {
    let projectSkillsVs = this.projectSkillsVs(project) || {};
    this.setState({
      eventId: this.uuid(),
      selectedProject: project,
      relatedSkillsVsExperience: this.relatedSkillsVsExperience(project),
      projectSkillsVsExperience: projectSkillsVs.experience,
      projectSkillsVsProjectCount: projectSkillsVs.projectCount
    });
    this.transitionDetailBackground(project, this.state.selectedProject);
  }

  onSelectedSkillChange = (skill)=> {
    this.setState({ selectedSkill: skill })
  }

  relatedSkillsVsExperience(project, maxResults = 5) {
    let selectedType = project.type;
    let result = {};
    let resultCount = 0;

    for (let skill of this.state.indexData) {
      for (let project of skill.projects) {
        if (project.type === selectedType && !result[skill.name]) {
          result[skill.name] = skill.experience;
          resultCount += 1;
        }

        if (resultCount === maxResults) {
          return this.objectToChartData(result);
        }
      }
    }

    return this.objectToChartData(result);
  }

  objectToChartData(object) {
    return Object.keys(object).map(function(key) {
      return { name: key, value: object[key] };
    });
  }

  includesProject(skill, project) {
    return skill.projects.find(function(skillProject) {
      return skillProject.name === project.name;
    });
  }

  projectSkillsVs(project) {
    let experience = [];
    let projectCount = [];
    this.state.indexData.forEach((skill)=> {
      if (this.includesProject(skill, project)) {
        experience.push({ name: skill.name, value: skill.experience });
        projectCount.push({ name: skill.name, value: skill.projects.length });
      }
    });
    return { experience: experience, projectCount: projectCount };
  }

  transitionDetailBackground(newProject, oldProject) {
    this.backLayerEl.className = 'back-layer ' + newProject.type;
    this.detailEl.classList.add('in-transition');

    setTimeout(()=> {
      this.detailEl.className = 'detail ' + newProject.type;
    }, 1000);
  }

  closeMainMenu = ()=> {
    this.setState({ mainMenuClass: 'main-menu' });
  }

  toggleMainMenuClass = ()=> {
    this.setState({ mainMenuClass: this.state.mainMenuClass === 'main-menu' ? 'main-menu open' : 'main-menu' });
  }

  enterFullScreen() {
    let el = document.documentElement;
    if(el.webkitRequestFullScreen) {
      el.webkitRequestFullScreen();
    }
    else if(el.requestFullScreen) {
      el.requestFullScreen();
    }
    else if(el.mozRequestFullScreen) {
      el.mozRequestFullScreen();
    }
  }

  exitFullScreen() {
    if (document.exitFullscreen) {
    	document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
    	document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
    	document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
    	document.msExitFullscreen();
    }
  }

  toggleFullScreen = ()=> {
    if (this.state.isFullScreen) {
      this.setState({ isFullScreen: false });
      this.exitFullScreen();
    } else {
      this.setState({ isFullScreen: true });
      this.enterFullScreen();
    }

    this.closeMainMenu();
  }

  showGallery = (photoIndex)=> {
    this.setState({ isGalleryVisible: true, currentPhotoIndex: photoIndex });
  }

  galleryClosed = ()=> {
    this.setState({ isGalleryVisible: false });
  }

  viewToggle = ()=> {
    if (this.state.isResumeViewVisible) {
      this.setState({ isResumeViewVisible: false });
    } else {
      this.setState({ isResumeViewVisible: true });
    }
    this.closeMainMenu();
  }

  configureBodyClass = ()=> {
    if (this.state.isResumeViewVisible) {
      document.body.classList.add('resume-view-is-visible');
    } else {
      document.body.classList.remove('resume-view-is-visible');
    }

    if (this.state.isGalleryVisible) {
      document.body.classList.add('gallery-is-visible')
    } else {
      document.body.classList.remove('gallery-is-visible');
    }
  }

  showRandomProjectOnResumeView = ()=> {
    let projectScreenshots = this.state.projectScreenshots;
    let randIndex = Math.floor(Math.random() * projectScreenshots.length);
    let randomImage = projectScreenshots[randIndex];
    this.setState({
      selectedProjectImages: [randomImage],
      currentPhotoIndex: 0,
      isGalleryVisible: true
    });
  }

  hideWelcomePanel = ()=> {
    this.welcomePanel.classList.add('hidden');
    window.localStorage.setItem('welcomePreviouslyViewed', true);
    this.setState({ welcomePreviouslyViewed: true });
  }

  render() {
    this.configureBodyClass();

    let fullScreenClassName = 'icon-enlarge';
    if (this.state.isFullScreen) {
      fullScreenClassName = 'icon-shrink';
    }

    let selectedProjectName = this.state.selectedProject ? this.state.selectedProject.name : '';
    let selectedProjectScreenshots = [];
    let welcomePanelClassName = this.state.welcomePreviouslyViewed ? 'welcome hidden' : 'welcome';
    if (this.state.isResumeViewVisible) {
      selectedProjectScreenshots = this.state.selectedProjectImages;
      welcomePanelClassName += ' hidden';
    } else if (this.state.selectedProject) {
      selectedProjectScreenshots = this.state.selectedProject.images;
    }

    return (
      <div className='main'>

        <div className={ welcomePanelClassName } ref={(el)=> { this.welcomePanel = el; }} onClick={ this.hideWelcomePanel }>
          <div className="panel message">
            <h2>Hello,</h2>
            <p>Thank you for checking out this dashboard.<br /><strong>Here is how it works:</strong></p>
          </div>
          <div className="panel search-instructions">
            <i className="icon-arrow_upward"></i>
            Type something here to search for a skill, ex: rails, ember
          </div>
          <div className="panel drag-instructions">
            <i className="icon-settings_ethernet"></i>
            Drag here to spin the project index.
          </div>
          <div className="panel select-instructions">
            <div className="arrows">
              <i className="icon-arrow_upward left"></i>
              <i className="icon-arrow_upward"></i>
              <i className="icon-arrow_upward right"></i>
            </div>
            Each dot represents a project I worked on.
            Click on a dot to get more information about the project, and data about the skills required to complete it.
          </div>
        </div>

        <header className="main-header">
          <h1>Jacek Pakulski</h1>
          <section className="contact-details">
            Creative Developer in
            <a href="https://goo.gl/maps/F9a1thLV24N2" target="_blank" alt="Click to view Tauranga on a map">
              Tauranga
            </a>, New Zealand
          </section>

          <div className="selected-project">
            <h2>Selected Project</h2>
            <h3>{ selectedProjectName }</h3>
          </div>

          <nav className={ this.state.mainMenuClass }>
            <button className="burger" onClick={ this.toggleMainMenuClass }>
              <div className="lines">
                <div className="line top"></div>
                <div className="line mid"></div>
                <div className="line bottom"></div>
              </div>
            </button>
            <div className="main-menu-content">
              <button className="menu-item toggle-fullscreen-menu-item" alt="Toggle fullscreen mode" onClick={ this.toggleFullScreen }>
                <i className={ fullScreenClassName }></i>
                <span className="menu-label">Toggle fullscreen mode</span>
              </button>
              <a className="menu-item hidden" href="#bitbucket" alt="View source code for this project on bitbucket">
                <i className='icon-bitbucket'></i>
                <span className="menu-label">view source</span>
              </a>
              <a className="menu-item" href="mailto:j@megdrive.com?subject=Enquiry From Resume Dashboard" alt="Send me an email" target="_blank">
                <i className='icon-envelope-open-o'></i>
                <span className="menu-label">email me</span>
              </a>
              <a className="menu-item" href="https://megdrive.com" alt="Read my blog" target="_blank">
                <i className='icon-question_answer'></i>
                <span className="menu-label">read my blog</span>
              </a>
              {
                this.state.isResumeViewVisible
                ? <button className="menu-item" alt="View Jacek's skills dashboard" onClick={ this.viewToggle }>
                  <i className='icon-stats-bars'></i>
                  <span className="menu-label">view my skills dashboard</span>
                </button>
                : <button className="menu-item" alt="View Jacek's resume" onClick={ this.viewToggle }>
                  <i className='icon-file-text-o'></i>
                  <span className="menu-label">view my resume</span>
                </button>
              }
              <a className="menu-item" href="/jacek_pakulski_resume_2017.pdf" alt="Download the PDF version of my resume" target="_blank">
                <i className='icon-download'></i>
                <span className="menu-label">download my resume</span>
              </a>
              <a className="menu-item" href="https://www.linkedin.com/in/jacek-pakulski" alt="Visit my linked in profile" target="_blank">
                <i className='icon-linkedin'></i>
                <span className="menu-label">view my LinkedIn</span>
              </a>
              <button className="menu-item show-random-project-menu-item" alt="Show a random project" onClick={ this.selectedRandomProject }>
                <i className='icon-shuffle'></i>
                <span className="menu-label">select random project</span>
              </button>
            </div>
          </nav>
        </header>
        <section class="main-content">
          <section className="detail" ref={(el) => { this.detailEl = el; }}>
            <div className="columns">
              <div className="column">
                <h2>Experience</h2>
                <BarChart data={ this.state.relatedSkillsVsExperience } currentSkill={ this.state.selectedSkill } />
              </div>
              <div className="column">
                <h2>Confidence</h2>
                <BarChart data={ this.state.projectSkillsVsExperience } currentSkill={ this.state.selectedSkill } />
              </div>
              <div className="column">
                <h2>Project Count</h2>
                <BarChart data={ this.state.projectSkillsVsProjectCount } currentSkill={ this.state.selectedSkill } />
              </div>
            </div>
            <Search searchString={ this.state.searchString } onInput={ this.handleSearchStringChange } />
            <div className="back-layer" ref={(el)=> { this.backLayerEl = el; }}></div>
          </section>

          <section className="index">
            <RadialChart
              selectedSkill={ this.state.selectedSkill }
              selectedProject={ this.state.selectedProject }
              data={ this.state.indexData }
              onSelectProject={ this.onSelectProject }
              onSelectedSkillChange={ this.onSelectedSkillChange } />

            <ProjectInfo data={ this.state.selectedProject }
              eventId={ this.state.eventId }
              onScreenshotClick={ this.showGallery }
              isGalleryVisible={ this.state.isGalleryVisible } />
          </section>
        </section>
        <Gallery photos={ selectedProjectScreenshots }
          currentPhotoIndex={ this.state.currentPhotoIndex }
          isVisible={ this.state.isGalleryVisible }
          onClose={ this.galleryClosed } />
        <ResumeView viewToggle={ this.viewToggle } showRandomProject={ this.showRandomProjectOnResumeView }/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App/App.js